import { render, staticRenderFns } from "./BaseGiftPack.vue?vue&type=template&id=538787ea&scoped=true&"
import script from "./BaseGiftPack.vue?vue&type=script&lang=js&"
export * from "./BaseGiftPack.vue?vue&type=script&lang=js&"
import style0 from "./BaseGiftPack.vue?vue&type=style&index=0&id=538787ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538787ea",
  null
  
)

export default component.exports